module.exports = __webpack_public_path__ + "img/right-long.75ab90ec.svg";